import { Language } from './enums'

const EN_SUPPORT_URL = 'https://support.faceup.com/en/how-to-ensure-security-when-sending-reports'

const CZ_SUPPORT_URL =
  'https://support.faceup.com/cs/jak-zajistit-bezpecnost-pri-odesilani-oznameni'

export const getSupportUrlByLanguage = (language: Language) => {
  switch (language) {
    case Language.Cs:
    case Language.Sk:
      return CZ_SUPPORT_URL
    default:
      return EN_SUPPORT_URL
  }
}
